import { useState } from "react";

// This hook is used to create a unique key for the fetcher
// This is used to prevent the fetcher from being reused
// when the component is unmounted and mounted again
export const useFetcherKey = () => {
  const [fetcherKey] = useState<string>(() => Date.now().toString());

  return { fetcherKey };
};
